"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldDropdownCoreInputs = void 0;
class EmeraldDropdownCoreInputs {
    constructor() {
        this.options = [];
        this.multiSelect = false;
        this.id = `dropdown${Math.random()}`;
        this.label = `Select Item`;
        this.disabled = false;
        this.required = false;
        this.outlined = true;
        this.classes = '';
        this.isValid = true;
        this.editable = true;
        this.size = 'default';
        this.asterisk = true;
    }
}
exports.EmeraldDropdownCoreInputs = EmeraldDropdownCoreInputs;
//# sourceMappingURL=dropdown.inputs.js.map